"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Loading = exports.LoadingTheme = void 0;
var react_1 = __importDefault(require("react"));
var react_loading_skeleton_1 = __importStar(require("react-loading-skeleton"));
var LoadingTheme;
(function (LoadingTheme) {
    LoadingTheme[LoadingTheme["WHITE"] = 0] = "WHITE";
    LoadingTheme[LoadingTheme["CUSTOM"] = 1] = "CUSTOM";
})(LoadingTheme = exports.LoadingTheme || (exports.LoadingTheme = {}));
var Loading = function (_a) {
    var _b = _a.customClasses, customClasses = _b === void 0 ? "" : _b, theme = _a.theme, _c = _a.color, color = _c === void 0 ? "#F2F5F5" : _c, _d = _a.highlightColor, highlightColor = _d === void 0 ? "#f9f9f9" : _d, _e = _a.duration, duration = _e === void 0 ? 1.2 : _e, _f = _a.count, count = _f === void 0 ? 1 : _f, height = _a.height, width = _a.width, _g = _a.circle, circle = _g === void 0 ? false : _g;
    var _color;
    var _highlightColor;
    switch (theme) {
        case LoadingTheme.CUSTOM:
            _color = color;
            _highlightColor = highlightColor;
            break;
        case LoadingTheme.WHITE:
            _color = "#FFFF";
            _highlightColor = "#F2F5F5";
            break;
        default:
            _color = "#F2F5F5";
            _highlightColor = "#f9f9f9";
    }
    return (react_1.default.createElement("div", { className: "axxes-skeleton " + (customClasses !== null && customClasses !== void 0 ? customClasses : "") },
        react_1.default.createElement(react_loading_skeleton_1.SkeletonTheme, { color: _color, highlightColor: _highlightColor },
            react_1.default.createElement(react_loading_skeleton_1.default, { duration: duration, count: count, height: height, width: width, circle: circle }))));
};
exports.Loading = Loading;
